import H from '@here/maps-api-for-javascript';
import '@here/maps-api-for-javascript/bin/mapsjs-ui.css';
import config from 'config';

export const MAX_MAP_ZOOM = 18;
export const MIN_MAP_ZOOM = 2;
export const UI_CONTROLS = {
  ZOOM: 'zoom',
  MAP_SETTINGS: 'mapsettings',
  SCALEBAR: 'scalebar',
};

export const createBaseLayers = (engineType, language, ISO2Code) => {
  const providerOptions = {
    engineType,
    lg: language,
  };
  const platform = new H.service.Platform({
    apikey: process.env.REACT_APP_AK,
    ...providerOptions,
  });

  const omvService = platform.getOMVService({
    path: 'v2/vectortiles/core/mc',
    queryParams: {
      content: 'default',
      datasets: '(-pois)',
    },
  });

  const baseUrl = config.map.stylesBaseUrl;
  const defaultLayers = platform.createDefaultLayers(providerOptions);
  const tileOptions = { min: MIN_MAP_ZOOM, max: MAX_MAP_ZOOM };

  const normalStyle = new H.map.render.harp.Style(`${baseUrl}/${config.map.styles.normal}`);
  const normalProvider = new H.service.omv.Provider(omvService, normalStyle, providerOptions);
  const normal = new H.map.layer.TileLayer(normalProvider, tileOptions);

  const hybridStyle = new H.map.render.harp.Style(`${baseUrl}/${config.map.styles.hybrid}`);
  const hybridProvider = new H.service.omv.Provider(omvService, hybridStyle, providerOptions);
  const hybrid = new H.map.layer.TileLayer(hybridProvider);

  omvService.getPoliticalViews(
    (views) => {
      if (views.core.includes(ISO2Code?.toLowerCase())) {
        normalProvider.setPoliticalView(ISO2Code);
        hybridProvider.setPoliticalView(ISO2Code);
      }
    },
    () => {},
  );

  return { normal, hybrid, satellite: defaultLayers.raster.satellite.xbase };
};

export const createSettingsControl = (mapLayers) => {
  return new H.ui.MapSettingsControl({
    baseLayers: [
      { label: 'Map', layer: mapLayers.normal },
      { label: 'Satellite', layer: [mapLayers.satellite, mapLayers.hybrid] },
    ],
    alignment: H.ui.LayoutAlignment.BOTTOM_RIGHT,
  });
};

export const createBehaviour = (map) => {
  return new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
};

export const createUI = (mapLayers, map, mapSettingsControl) => {
  const scalebarControl = new H.ui.ScaleBar({
    alignment: H.ui.LayoutAlignment.BOTTOM_RIGHT,
  });
  const zoomControl = new H.ui.ZoomControl({
    alignment: H.ui.LayoutAlignment.RIGHT_BOTTOM,
  });

  const ui = new H.ui.UI(map);
  ui.addControl(UI_CONTROLS.ZOOM, zoomControl);
  ui.addControl(UI_CONTROLS.MAP_SETTINGS, mapSettingsControl);
  ui.addControl(UI_CONTROLS.SCALEBAR, scalebarControl);

  return ui;
};

export const createMap = (mapLayers, mapRef, engineType) => {
  const newMap = new H.Map(mapRef.current, mapLayers.normal, {
    zoom: 14,
    center: { lat: 52.531, lng: 13.38461 },
    engineType,
  });
  const behavior = createBehaviour(newMap);
  newMap._behavior = behavior;

  const onResize = () => newMap.getViewPort().resize();
  window.addEventListener('resize', onResize);
  newMap._resizeHandler = onResize;

  return newMap;
};

export const setUnitSystem = (mapUI, metricSystem) => {
  mapUI.setUnitSystem(
    metricSystem === 'metric' ? H.ui.UnitSystem.METRIC : H.ui.UnitSystem.IMPERIAL,
  );
};
